import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { Departments } from '@app/api/greenhouse/types'

import { CareersState } from './types'

const INITIAL_STATE: CareersState = {
  status: 'initial',
  careersData: null,
  error: ''
}

export const slice = createSlice({
  name: 'careers',
  initialState: INITIAL_STATE,

  reducers: {
    requestFetchJobs: state => {
      state.status = 'pending'
    },
    successFetchJobs: (state, action: PayloadAction<Departments>) => {
      state.status = 'success'
      state.careersData = action.payload
    },
    errorFetchJobs: (state, action: PayloadAction<string>) => {
      state.status = 'failure'
      state.error = action.payload
    }
  }
})

export const { actions } = slice
export const careersReducer = slice.reducer
